import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import Esign from "src/components/common/esign";
import Sketch from "src/components/common/sketch";
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, 
    MyFormData, 
    MyDate, 
    Select, 

    arrayReducer, 
    calibrationVerificationFormApprovers, 
    auditFormApprovers, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Form({
    picData, setPicData, 
    sketches, setSketches,
    closeIt, form, items,

    picsLimit, 

    setUserList, usersList, 

    forms
}){
    const [showSketch, setShowSketch] = useState(false);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const defaultApprover = form.approverEmail?
    usersList.find(u => u.email === form.approverEmail)
    :{value: "", label: ""};
    const [curApprover, setApprover] = useState(defaultApprover);
    //--------------------------------------------------------------------------------------------
    const formContent = (
        form.formContent?
        Object.fromEntries(
            items.map(f =>
            f.type === "latlng"?
            [
                ["latitude", JSON.parse(form.formContent).latitude || ""], 
                ["longitude", JSON.parse(form.formContent).longitude || ""]
            ]:(
            f.title === "Project"?
            [
                ["projectHashKey", JSON.parse(form.formContent).projectHashKey || ""],
                ["Project Name", JSON.parse(form.formContent)["Project Name"] || ""]
            ]:(
            f.type === "display"?
            [
                
            ]:([
                [f.title, JSON.parse(form.formContent)[f.title] ?? f.default]
            ])))
        ).reduce(arrayReducer, []))
        :
        Object.fromEntries(items.map(f => [f.title, f.default || ""]))
    );
    const [itemChecked, setItemChecked] = useState(formContent);
   //--------------------------------------------------------------------------------------------
    const handleFormSubmit = async e => {
        e.preventDefault();
        if(form.formType === "Weekly Maintenance Zerk Fittings" && forms.some(thisForm => 
            JSON.parse(thisForm.formContent || "{}")["Truck Number"] === itemChecked["Truck Number"] && 
            JSON.parse(thisForm.formContent || "{}")["Date"] === itemChecked["Date"] && 
            thisForm.formHashKey !== form.formHashKey
        )){
            window.alert("This truck on this date has already filed a form. Please check on the system.");
            return;
        }
        if(!picData.length){
            window.alert("Please sign!");
            return; 
        }
        const formData = new MyFormData(e.currentTarget);
        if(!formData.get("approverEmail")){
            window.alert("The approver is not selected.");
            return;
        }
        formData.append("form", "form");//g
        //-----------------------------------------------------------
        formData.append("formHashKey", form.formHashKey);
        formData.append("laborFolderId", user.folderId);
        //-----------------------------------------------------------
        formData.append("sketches", JSON.stringify(sketches.map(e => ({
            ...e, sketchBgImg: e.sketchBgImg?[
                e.sketchBgImg[0].src, 
                e.sketchBgImg[1],
                e.sketchBgImg[2],
                e.sketchBgImg[3],
                e.sketchBgImg[4]
            ]:""
        }))));
        formData.append("submitTime", (new MyDate()).ss());
        formData.append("signData", JSON.stringify(picData));
        formData.append("sign", document.getElementById("esign").toDataURL());
        formData.append("data", JSON.stringify(itemChecked));
        formData.append("title", form.formType.toUpperCase());
        formData.append("formType", form.formType);
        formData.append("signId", form.signId);
        formData.append("sketchesId", form.sketchesId);
        formData.append("formId", form.id);
        formData.append("docId", form.docId);
        formData.append("action", "Submit");//g
        formData.append("formContent", JSON.stringify(itemChecked));
        //---------------------------------------------------------------
        setShowLoader(true);
        const vehicleFormRes = await myAxios("forms/checklist.php", formData);
        setShowLoader(false);
        if(!vehicleFormRes) return;
        //---------------------------------------------------------------
        setUserList(forms => forms.map(f => 
            f.formHashKey === form.formHashKey?
            vehicleFormRes.data:
            f
        ));
        closeIt();
    }
    const handleFormSave = async () => {
        if(form.formType === "Weekly Maintenance Zerk Fittings" && forms.some(thisForm => 
            JSON.parse(thisForm.formContent || "{}")["Truck Number"] === itemChecked["Truck Number"] && 
            JSON.parse(thisForm.formContent || "{}")["Date"] === itemChecked["Date"] && 
            thisForm.formHashKey !== form.formHashKey
        )){
            window.alert("This truck on this date has already filed a form. Please check on the system.");
            return;
        }
        const formData = new MyFormData();
        formData.append("approverEmail", curApprover?.email || "");
        //-----------------------------------------------------------
        formData.append("formHashKey", form.formHashKey);
        formData.append("laborFolderId", user.folderId);
        //-----------------------------------------------------------
        formData.append("sketches", JSON.stringify(sketches.map(e => ({
            ...e, sketchBgImg: e.sketchBgImg?[
                e.sketchBgImg[0].src, 
                e.sketchBgImg[1],
                e.sketchBgImg[2],
                e.sketchBgImg[3],
                e.sketchBgImg[4]
            ]:""
        }))));
        formData.append("submitTime", (new MyDate()).ss());
        formData.append("signData", JSON.stringify(picData));
        formData.append("sign", document.getElementById("esign").toDataURL());
        formData.append("data", JSON.stringify(itemChecked));
        formData.append("title", form.formType.toUpperCase());
        formData.append("formType", form.formType);
        formData.append("signId", form.signId);
        formData.append("sketchesId", form.sketchesId);
        formData.append("formId", form.id);
        formData.append("docId", form.docId);
        formData.append("action", "Save");
        formData.append("formContent", JSON.stringify(itemChecked));
        //---------------------------------------------------------------
        setShowLoader(true);
        const vehicleFormRes = await myAxios("forms/checklist.php", formData);
        setShowLoader(false);
        if(!vehicleFormRes) return;
        //---------------------------------------------------------------
        setUserList(forms => forms.map(f => 
            f.formHashKey === form.formHashKey?
            vehicleFormRes.data:
            f
        ));
        closeIt();
    }
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("formHashKey", form.formHashKey);
            formData.append("action", "Read");
            //---------------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("forms/checklist.php", formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------------------
            setPicData(JSON.parse(res.data.sign && (res.data.sign.indexOf("error") === -1)?res.data.sign:"[]")||[]);
            const sketches = JSON.parse(res.data.sketches && (res.data.sketches.indexOf("error") === -1)?res.data.sketches:"[]") || [];
            sketches.forEach(e => {
                if(e.sketchBgImg){
                    const img = new Image();
                    img.src = e.sketchBgImg[0];
                    e.sketchBgImg[0] = img; 
                }
            })
            setSketches(sketches||[]);
        }
        getData();
        return () => {isMounted = false;}
    },[form.formHashKey, form.foreignKey, setPicData, setSketches]);
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {form.formType.toUpperCase()}
            width = {800}
            maxWidth = {"100%"}
            handleFormSubmit = {handleFormSubmit}
            // Per Danny 6/1/2026 they no longer want these excluded forms excluded from submit
            actionKey = {
                ["Rental Form", "Return Form"].includes(form.formType)?"Submit":
                "Submit"
            }
            onSave = {handleFormSave}
        >
            <div className = "my-3"/>
            <div>
                {items.filter(item =>
                !form.dateSubmitted?
                item.title !== "Approver Notes":true
                ).map((item, itemNumber) => 
                (!item.parentNo || itemChecked[item.parentNo] !== "Yes") &&
                (!item.parentYes || itemChecked[item.parentYes] !== "No") 
                ?
                <label htmlFor = {item.title} key = {itemNumber} className = "blk5 mb-2 d-flex align-items-center">
                    {item.type === "display"?item.content:<div className = {`font-weight-bold mr-3` + (item.nowrap?" text-nowrap":"")}>{item.showTitle ?? item.title}</div>}
                    {item.type === "latlng"?<>
                    <label htmlFor = "lat" className = "font-weight-bold mr-3">Latitude:</label>
                    <input
                        id = "lat"
                        type = "number"
                        step = "any"
                        className = "form-control text-center flex-grow-1 mr-3"
                        required = {itemChecked.longitude}
                        name = "latitude"
                        value = {itemChecked.latitude || ""}
                        onChange = {e => {
                            const value = e.currentTarget.value;
                            setItemChecked(itemChecked => ({
                                ...itemChecked, 
                                latitude: value, 
                                [item.title]: value && itemChecked.longitude?
                                `${value}, ${itemChecked.longitude}`:""}));
                        }} 
                    />
                    <label htmlFor = "lng" className = "font-weight-bold mr-3">Longitude:</label>
                    <input
                        id = "lng"
                        type = "number" step = "any"
                        className = "form-control text-center flex-grow-1 mr-3"
                        required = {itemChecked.latitude}
                        name = "longitude"
                        value = {itemChecked.longitude || ""}
                        onChange = {e => {
                            const value = e.currentTarget.value;
                            setItemChecked(itemChecked => ({
                                ...itemChecked, 
                                longitude: value, 
                                [item.title]: value && itemChecked.latitude?
                                `${itemChecked.latitude}, ${value}`:""
                            }));
                        }}
                    />
                    <label>
                        <span className = "btn btn-primary mr-3" onClick = {() => {
                            if(navigator.geolocation){
                                navigator.geolocation.getCurrentPosition(pos => {
                                    setItemChecked({
                                        ...itemChecked, 
                                        latitude: pos.coords.latitude, 
                                        longitude: pos.coords.longitude, 
                                        [item.title]:`${pos.coords.latitude}, ${pos.coords.longitude}`
                                    });
                                }, error => alert(error.message), {enableHighAccuracy: true, timeout: 5000});
                            }else{
                                setItemChecked(itemChecked => ({...itemChecked, latitude: "", longitude: "", [item.title]: ""}));
                            }
                        }}>
                            Get Location
                        </span>
                        <span>(GIS Grade)</span>
                    </label>
                    </>:<></>}
                    {item.type === "Select"?
                    <div className = "w-100">
                    <Select
                        iputId = {item.title}
                        value = {item.options
                            .find(option => 
                                option.value
                                ===
                                itemChecked[item.title]
                            )
                        }
                        options = {item.options}
                        onChange = {e => {
                            setItemChecked(itemChecked => ({
                                ...itemChecked, 
                                [item.title]: e?.value ?? "",
                            }));
                        }}
                    />
                    </div>:<></>}
                    {item.type === "select"?
                    <select
                        id = {item.title}
                        disabled = {item.disabled}
                        className = "form-control"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] || ""}
                        onChange = {e => {
                            const target = e.currentTarget;
                            setItemChecked(itemChecked => ({
                                ...itemChecked, 
                                [target.name]: target.value
                            }));
                        }}
                    >
                        <option value = "">Select</option>
                        {item.options.map((option, optionIndex) => <option key = {optionIndex} value = {option.value}>{option.label}</option>)}
                    </select>
                    :<></>}
                    {item.type === "textarea"?
                    <textarea
                        id = {item.title}
                        rows = {6}
                        className = "form-control text-center flex-grow-1"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] || ""}
                        onChange = {e => {
                            const target = e.currentTarget;
                            setItemChecked(itemChecked => ({
                                ...itemChecked, 
                                [target.name]: target.value
                            }));
                        }}
                    />
                    :<></>}
                    {item.type === "audit"?<>
                    <select id = {item.title} required className = "form-control mr-3" name = {item.title}
                        value = {itemChecked[item.title].split(", ")[0] || ""}
                        onChange = {e => {
                            const target = e.currentTarget;
                            const options = ["High", "Medium", "Low", "Fail"];
                            const splited = (itemChecked[target.name] || "").split(", ");
                            if(options.includes(splited[0])){
                                if(target.value === ""){
                                    splited.shift();
                                }else{
                                    splited[0] = target.value;
                                }
                            }else{
                                if(target.value !== ""){
                                    splited.unshift(target.value);
                                }
                            }
                            setItemChecked(itemChecked => ({
                                ...itemChecked, 
                                [target.name]: splited.join(", ")
                            }));
                        }}
                    >
                        <option value = {""}>Select</option>
                        <option>High</option>
                        <option>Medium</option>
                        <option>Low</option>
                        <option>Fail</option>
                    </select>
                    <textarea
                        className = "form-control text-center flex-grow-1"
                        name = {item.title}
                        value = {
                            itemChecked[item.title].split(", ").length === 1?
                                (["High", "Medium", "Low", "Fail"].includes(itemChecked[item.title].split(", ")[0])?
                                ""
                                :
                                itemChecked[item.title].split(", ")[0])
                                :
                                (["High", "Medium", "Low", "Fail"].includes(itemChecked[item.title].split(", ")[0])?
                                itemChecked[item.title].split(", ").slice(1).join(", ")
                                :
                                itemChecked[item.title].split(", ").join(", "))
                            || ""
                        }
                        onChange = {e => {
                            const target = e.currentTarget;
                            const splited = (itemChecked[target.name] || "").split(", ");
                            const options = ["High", "Medium", "Low", "Fail"];
                            let value = "";
                            if(options.includes(splited[0])){
                                if(target.value === ""){
                                    value = splited[0];
                                }else{
                                    value = splited[0] + ", " + target.value;
                                }
                            }else{
                                value = target.value;
                            }
                            setItemChecked(itemChecked => ({
                                ...itemChecked, 
                                [target.name]: value
                            }));
                        }}
                    />
                    </>:<></>}
                    {item.type === "text"?
                    <input
                        id = {item.title}
                        type = "text"
                        placeholder = {item.example}
                        className = "form-control"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] || ""}
                        onChange = {e => {
                            const target = e.currentTarget;
                            setItemChecked(itemChecked => ({
                                ...itemChecked, 
                                [target.name]: target.value
                            }));
                        }}
                    />
                    :<></>}
                    {item.type === "date"?
                    <input
                        id = {item.title}
                        type = "date"
                        min = {item.min ?? "1900-01-01"}
                        max = {item.max ?? "2999-12-31"}
                        className = "text-center form-control flex-grow-1"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] ?? ""}
                        onChange = {e => {
                            const target = e.currentTarget;
                            setItemChecked(itemChecked => ({
                                ...itemChecked, 
                                [target.name]: target.value
                            }));
                        }}
                    />
                    :<></>}
                    {item.type === "time"?
                    <input
                        id = {item.title}
                        type = "time"
                        min = {item.min}
                        max = {item.max}
                        className = "text-center form-control flex-grow-1"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] ?? ""}
                        onChange = {e => {
                            const target = e.currentTarget;
                            setItemChecked({
                                ...itemChecked, 
                                [target.name]: target.value
                            });
                        }}
                    />
                    :<></>}
                    {item.type === "number"?
                    <input
                        id = {item.title}
                        type = "number"
                        step = "any"
                        className = "form-control"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] || ""}
                        onChange = {e => {
                            const target = e.currentTarget;
                            setItemChecked(itemChecked => ({
                                ...itemChecked, 
                                [target.name]: target.value
                            }));
                        }}
                    />
                    :<></>}
                    {item.type === "radio"?<>
                    <input
                        type = "radio"
                        required = {item.required}
                        id = {item.title + " Yes"}
                        name = {item.title}
                        checked = {(
                            itemChecked[item.title] && 
                            itemChecked[item.title].substring(0, 3) === "Yes"
                        ) || false}
                        value = {`Yes`}
                        onChange = {e => {
                            const target = e.currentTarget;
                            if(target.checked){
                                setItemChecked(itemChecked => ({
                                    ...itemChecked, 
                                    [target.name]: target.value
                                }));
                            }
                        }}
                        className = "mr-2 cssCheckBox"
                    />
                    <label htmlFor = {item.title + " Yes"} className = "mr-3 mb-0">Yes</label>
                    <input
                        type = "radio"
                        required = {item.required}
                        id = {item.title + " No"}
                        name = {item.title}
                        checked = {(
                            itemChecked[item.title] && 
                            itemChecked[item.title].substring(0, 2) === "No"
                        ) || false}
                        value = {`No`}
                        onChange = {e => {
                            const target = e.currentTarget;
                            if(target.checked){
                                setItemChecked(itemChecked => ({
                                    ...itemChecked, 
                                    [target.name]: target.value
                                }));
                            }
                        }}
                        className = "mr-2 cssCheckBox"
                    />
                    <label htmlFor = {item.title + " No"} className = "mr-3 mb-0">No</label>
                    </>:<></>}
                    {itemChecked[item.title] === "No" && item.onNoText?<>
                    <label>{item.onNoText}</label>
                    </>:<></>}
                    {itemChecked[item.title] === "Yes" && item.onYesText?<>
                    <label>{item.onYesText}</label>
                    </>:<></>}
                    {itemChecked[item.title] && itemChecked[item.title].substring(0, 2) === "No" && item.onNo?<>
                    {item.onNo === "textarea"?
                        <textarea
                            rows = {6}
                            className = "form-control text-center flex-grow-1"
                            required = {item.required}
                            name = {item.title}
                            value = {itemChecked[item.title].substring(4) || ""}
                            onChange = {e => {
                                const target = e.currentTarget;
                                setItemChecked(itemChecked => ({
                                    ...itemChecked, 
                                    [target.name]:`No, ${target.value}`
                                }))
                            }}
                    />:<></>}
                    {item.onNo === "text"?
                    <input
                        type = {item.onNo}
                        className = "form-control"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title].substring(4) || ""}
                        onChange = {e => {
                            const target = e.currentTarget;
                            setItemChecked(itemChecked => ({
                                ...itemChecked, 
                                [target.name]:`No, ${target.value}`
                            }))
                        }}
                    />:<></>}
                    </>:<></>}
                    {itemChecked[item.title] && itemChecked[item.title].substring(0, 3) === "Yes" && item.onYes?<>
                        {item.onYes === "textarea"?
                        <textarea
                            rows = {6}
                            className = "form-control text-center flex-grow-1"
                            required = {item.required}
                            name = {item.title}
                            value = {itemChecked[item.title].substring(5) || ""}
                            onChange = {e => {
                                const target = e.currentTarget;
                                setItemChecked(itemChecked => ({
                                    ...itemChecked, 
                                    [target.name]: `Yes, ${target.value}`
                                }))
                            }}
                        />:<></>}
                        {item.onYes === "text"?
                        <input
                            type = {item.onYes}
                            className = "form-control"
                            required = {item.required}
                            name = {item.title}
                            value = {itemChecked[item.title].substring(5) || ""}
                            onChange = {e => {
                                const target = e.currentTarget;
                                setItemChecked(itemChecked => ({
                                    ...itemChecked, 
                                    [target.name]: `Yes, ${target.value}`
                                }))
                            }}
                        />:<></>}
                    </>:<></>}
                    {item.type === "object"?
                    <div className = "flex-grow-1">
                        {JSON.parse(itemChecked[item.title]).map((x, xi) => <div key = {xi} className = "border rounded p-2 m-2">
                        {item.schema.map((property, propertyIndex) => <div key = {propertyIndex} className = "d-flex align-items-center my-2">
                            <div className = "font-weight-bold mr-3">{property.title}</div>
                            {property.type === "radio"?<>
                            <input
                                type = "radio"
                                required = {property.required}
                                id = {item.title + " " + xi + " " + property.title + " Yes"}
                                name = {item.title + " " + xi + " " + property.title}
                                checked = {(
                                    JSON.parse(itemChecked[item.title])[xi][property.title] && 
                                    JSON.parse(itemChecked[item.title])[xi][property.title].substring(0, 3) === "Yes"
                                ) || false}
                                value = {`Yes`}
                                onChange = {e => {
                                    const target = e.currentTarget;
                                    if(target.checked){
                                        const arr = JSON.parse(itemChecked[item.title]);
                                        setItemChecked(itemChecked => ({
                                            ...itemChecked, 
                                            [item.title]: JSON.stringify([
                                                ...arr.slice(0, xi), 
                                                {...arr[xi], [property.title]: target.value},
                                                ...arr.slice(xi + 1)
                                            ])
                                        }));
                                    }
                                }}
                                className = "mr-2 cssCheckBox"
                            />
                            <label htmlFor = {x.title + " Yes"} className = "mr-3 mb-0">Yes</label>
                            <input
                                type = "radio"
                                required = {property.required}
                                id = {item.title + " " + xi + " " + property.title + " No"}
                                name = {item.title + " " + xi + " " + property.title}
                                checked = {(
                                    JSON.parse(itemChecked[item.title])[xi][property.title] && 
                                    JSON.parse(itemChecked[item.title])[xi][property.title].substring(0, 3) === "No"
                                ) || false}
                                value = {`No`}
                                onChange = {e => {
                                    const target = e.currentTarget;
                                    if(target.checked){
                                        const arr = JSON.parse(itemChecked[item.title]);
                                        setItemChecked(itemChecked => ({
                                            ...itemChecked, 
                                            [item.title]: JSON.stringify([
                                                ...arr.slice(0, xi), 
                                                {...arr[xi], [property.title]: target.value},
                                                ...arr.slice(xi + 1)
                                            ])
                                        }));
                                    }
                                }}
                                className = "mr-2 cssCheckBox"
                            />
                            <label htmlFor = {x.title + " No"} className = "mr-3 mb-0">No</label>
                            </>:<></>}
                            {property.type === "Select"?
                            <div className = "w-100">
                                <Select
                                    inputId = {property.title}
                                    value = {property.options
                                        .find(option => 
                                            option.value
                                            ===
                                            JSON.parse(itemChecked[item.title])[xi][property.title]
                                        )
                                    }
                                    options = {property.options}
                                    onChange = {e => {
                                        const arr = JSON.parse(itemChecked[item.title]);
                                        setItemChecked(itemChecked => ({
                                            ...itemChecked, 
                                            [item.title]: JSON.stringify([
                                                ...arr.slice(0, xi), 
                                                {...arr[xi], [property.title]: e?.value ?? ""},
                                                ...arr.slice(xi + 1)
                                            ])
                                        }));
                                    }}
                                />
                            </div>:<></>}
                            {property.type === "text"?
                            <input
                                id = {property.title}
                                type = "text"
                                required = {property.required}
                                className = "form-control text-center flex-grow-1"
                                value = {JSON.parse(itemChecked[item.title])[xi][property.title] || ""}
                                onChange = {e => {
                                    const value = e.currentTarget.value;
                                    const arr = JSON.parse(itemChecked[item.title]);
                                    setItemChecked(itemChecked => ({
                                        ...itemChecked, 
                                        [item.title]: JSON.stringify([
                                            ...arr.slice(0, xi), 
                                            {...arr[xi], [property.title]: value},
                                            ...arr.slice(xi + 1)
                                        ])
                                    }));
                                }}
                            />:<></>}
                            {property.type === "textarea"?
                            <textarea
                                id = {property.title}
                                required = {property.required}
                                className = "form-control text-center flex-grow-1"
                                value = {JSON.parse(itemChecked[item.title])[xi][property.title] || ""}
                                onChange = {e => {
                                    const value = e.currentTarget.value;
                                    const arr = JSON.parse(itemChecked[item.title]);
                                    setItemChecked(itemChecked => ({
                                        ...itemChecked, 
                                        [item.title]: JSON.stringify([
                                            ...arr.slice(0, xi), 
                                            {...arr[xi], [property.title]: value},
                                            ...arr.slice(xi + 1)
                                        ])
                                    }));
                                }}
                            />
                            :<></>}
                            {property.type === "select"?
                            <select
                                id = {property.title}
                                disabled = {property.disabled}
                                className = "form-control text-center flex-grow-1"
                                required = {property.required}
                                name = {property.title}
                                value = {JSON.parse(itemChecked[item.title])[xi][property.title] || ""}
                                onChange = {e => {
                                    const value = e.currentTarget.value;
                                    const arr = JSON.parse(itemChecked[item.title]);
                                    setItemChecked(itemChecked => ({
                                        ...itemChecked, 
                                        [item.title]: JSON.stringify([
                                            ...arr.slice(0, xi), 
                                            {...arr[xi], [property.title]: value},
                                            ...arr.slice(xi + 1)
                                        ])
                                    }));
                                }}
                            >
                                <option value = "">Select</option>
                                {property.options.map((option, optionIndex) => <option key = {optionIndex} value = {option.value}>{option.label}</option>)}
                            </select>
                            :<></>}
                            {property.type === "date"?
                            <input
                                id = {property.title}
                                type = "date"
                                min = {property.min ?? "1900-01-01"}
                                max = {property.max ?? "2999-12-31"}
                                className = "text-center form-control flex-grow-1"
                                required = {property.required}
                                name = {property.title}
                                value = {itemChecked[property.title] ?? ""}
                                onChange = {e => {
                                    const target = e.currentTarget;
                                    setItemChecked({
                                        ...itemChecked, 
                                        [target.name]: target.value
                                    });
                                }}
                            />
                            :<></>}
                        </div>)}
                        <button
                            type = "button"
                            className = "btn btn-danger"
                            onClick = {() => {
                                const arr = JSON.parse(itemChecked[item.title]);
                                setItemChecked(itemChecked => ({
                                    ...itemChecked, 
                                    [item.title]: JSON.stringify([
                                        ...arr.slice(0, xi), 
                                        ...arr.slice(xi + 1)
                                    ])
                                }));
                            }}
                        >
                            Delete
                        </button>
                        </div>)}
                        <button
                            type = "button"
                            className = "btn btn-success"
                            onClick = {() => {
                                setItemChecked(itemChecked => ({
                                    ...itemChecked, 
                                    [item.title]: JSON.stringify([...JSON.parse(itemChecked[item.title]), 
                                        Object.fromEntries(item.schema.map(f => [f.title, f.default || ""]))
                                    ])
                                }));
                            }}
                        >
                            Add
                        </button>
                    </div>:<></>}
                    {item.title === "Approver Notes" && form.dateSubmitted?
                    <textarea
                        rows = {6}
                        className = "form-control text-center flex-grow-1"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] || ""}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]:e.currentTarget.value
                            });
                        }}
                    />:<></>}
                </label>:<></>)}
            </div>
            <div className = "blk5 mb-2 d-flex">
                <label className = "font-weight-bold mr-3 required-field">Approver:</label>
                <div style = {{ minWidth: 200 }} className = "flex-grow-1">
                    <Select 
                        style = {{
                            container: base => ({
                            ...base,
                            flex: 1
                            })
                        }}
                        value = {curApprover}
                        onChange = {e => setApprover(e)}
                        options = {
                            form.formType === "Calibration Verification Form"?
                            usersList.filter(uu => calibrationVerificationFormApprovers.includes(uu.email)):
                            (form.formType === "Audit Form"?
                            usersList.filter(uu => auditFormApprovers.includes(uu.email)):
                            usersList.filter(uu => uu.purchases === "approver")
                            )
                        }
                    />
                    <input
                        className = "nodisplay" readOnly
                        name = "approverEmail" value = {curApprover?.email || ""}
                    />
                    <input
                        className = "nodisplay" readOnly
                        name = "approver" value = {curApprover?.label || ""}
                    />
                </div>
            </div>
            {picsLimit !== undefined?
            <Sketch 
                mainClassName = "mb-2"
                sketches = {sketches} 
                setSketches = {setSketches}
                limit = {picsLimit}
                showSketch = {showSketch}
                setShowSketch = {setShowSketch}
            />:<></>}
            <div className = "blk5 mb-2 d-flex">
                <label className = "required-field mr-3">Member name:</label>
                <input
                    type = "text"
                    className = "form-control mr-3 w-100"
                    readOnly
                    name = "memberName"
                    defaultValue = {/* workLog.userName || */ user.userName}
                />
                <label className = "required-field mr-3">Date:</label>
                <input
                    type = "text"
                    className = "form-control mr-3 w-100"
                    readOnly
                    name = "submitDate"
                    value = {(new MyDate()).s()}
                />
            </div>
            <Esign
                buttonClassName = "my-2"
                picData = {picData}
                setPicData = {setPicData}
            />
        </Modal>
    )    
}